import { ExternalConnection, FirestoreCollections, ID } from '@griply/types';

import { detachWrite } from '../detach-write';
import { FirestoreInstance } from '../types/firestore';
import { flattenSettings } from './update-user-settings';

export type UpdateExternalConnectionOptions<
  TDocRef = unknown,
  TFieldValue = unknown,
  TDb = FirestoreInstance,
> = {
  externalConnection: Pick<ExternalConnection, 'id'> &
    Partial<ExternalConnection>;
  doc: (db: NoInfer<TDb>, path: string, ...rest: string[]) => TDocRef;
  updateDoc: (
    ref: NoInfer<TDocRef>,
    data: Record<string, unknown>,
  ) => Promise<void>;
  db: TDb;
  serverTimestamp: () => TFieldValue;
  onWriteError: (error: unknown) => void;
};

export const updateExternalConnection = async <
  TDocRef,
  TFieldValue,
  TDb = FirestoreInstance,
>(
  options: UpdateExternalConnectionOptions<TDocRef, TFieldValue, TDb>,
): Promise<void> => {
  const {
    externalConnection,
    doc,
    updateDoc,
    db,
    serverTimestamp,
    onWriteError,
  } = options;

  if (!externalConnection.id) {
    return;
  }

  const ref = doc(
    db,
    FirestoreCollections.ExternalConnections,
    externalConnection.id as ID,
  );
  const flattened = flattenSettings(
    externalConnection as unknown as Record<string, unknown>,
  );

  detachWrite(
    updateDoc(ref, {
      ...flattened,
      updatedAt: serverTimestamp(),
    }),
    onWriteError,
  );
};
